import { API_URL } from '../config'; //live
import { makeApiCall } from '../_common/api.utils';

// Create Web Check-In
export const createWebCheckIn = async (data: FormData) => {
	const URL = `${API_URL}CreateEmployeeTemporaryAttendance`;
	return makeApiCall(URL, data);
};

// Fetch today's attendance status for an employee
export const getTodayAttendanceStatus = async (data: string) => {
	const URL = `${API_URL}GetEmployeeAttendanceStatus`;
	const requestData = {
		GetEmployeeAttendanceStatusToken: data,
	};
	return makeApiCall(URL, requestData);
};

// Regularize (update) existing attendance
export const regularizeAttendance = async (data: string) => {
	const URL = `${API_URL}RegularizeEmployeeAttendance`;
	const requestData = {
		RegularizeEmployeeAttendanceToken: data,
	};
	return makeApiCall(URL, requestData);
};